var _g, _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccoTileDesktop = function SvgAccoTileDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 856 240"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#acco-tile-desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "#EDEDED",
    rx: 4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 18,
    x: 336,
    fill: "#EDEDED",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 24,
    x: 336,
    y: 26,
    fill: "#EDEDED",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M413.526 45.11V33.182h.994V45.11h-.994Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    x: 425,
    y: 26,
    fill: "#EDEDED",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M336 58h376v24H336z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 376,
    height: 24,
    x: 336,
    y: 58,
    fill: "#EDEDED",
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M336 90h376v24H336zM336 122h376v24H336zM336 154h376v15H336zM728 120h128v24H728zM728 156h128v24H728z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 48,
    x: 728,
    y: 192,
    fill: "#EDEDED",
    rx: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "acco-tile-desktop_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgAccoTileDesktop;